var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sellsy-password-input" },
    [
      _c(
        "CompassInput",
        {
          staticClass: "sellsy-password-input__password",
          attrs: {
            type: _vm.type,
            readonly: _vm.readonly,
            placeholder: _vm.placeholder,
            size: _vm.size
          },
          on: {
            focus: function($event) {
              _vm.showBadges = true
              _vm.dirty = true
            },
            blur: function($event) {
              _vm.showBadges = false
            },
            change: function($event) {
              _vm.dirty = true
            }
          },
          model: {
            value: _vm.currentValue,
            callback: function($$v) {
              _vm.currentValue = $$v
            },
            expression: "currentValue"
          }
        },
        [
          _c(
            "template",
            { slot: "suffix" },
            [
              _c("CompassIconButton", {
                attrs: {
                  size: "small",
                  icon: _vm.showPassword ? "eyehide-fill" : "eyeshow-fill"
                },
                on: { click: _vm.toggleShow }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.showPasswordStrength
        ? _c(
            "transition-group",
            {
              staticClass: "password__badges",
              attrs: { tag: "div", name: "slide-in" }
            },
            [
              _c(
                "TagThird",
                {
                  key: 0,
                  class: _vm.hasCorrectLength
                    ? "password__badges-item--valid"
                    : "password__badges-item",
                  style: { "--i": 0 },
                  attrs: { type: "custom" }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "password__badges-item-content typographies-paragraph-medium-regular"
                    },
                    [
                      _c("CompassIcon", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasCorrectLength,
                            expression: "hasCorrectLength"
                          }
                        ],
                        attrs: {
                          type: "primary-contrast",
                          size: "small",
                          icon: "check"
                        }
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              "inputs.PasswordWithBadgeInput.between_min_and_max_characters",
                              {
                                min: _vm.minLength,
                                max: _vm.maxLength
                              }
                            )
                          ) +
                          "\n            "
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "TagThird",
                {
                  key: 1,
                  class:
                    _vm.hasUppercase && _vm.hasLowerCase
                      ? "password__badges-item--valid"
                      : "password__badges-item",
                  style: { "--i": 1 },
                  attrs: { type: "custom" }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "password__badges-item-content typographies-paragraph-medium-regular"
                    },
                    [
                      _c("CompassIcon", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasUppercase && _vm.hasLowerCase,
                            expression: "hasUppercase && hasLowerCase"
                          }
                        ],
                        attrs: {
                          type: "primary-contrast",
                          size: "small",
                          icon: "check"
                        }
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              "inputs.PasswordWithBadgeInput.one_upper_case_and_one_lower_case"
                            )
                          ) +
                          "\n            "
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "TagThird",
                {
                  key: 2,
                  class: _vm.hasNumber
                    ? "password__badges-item--valid"
                    : "password__badges-item",
                  style: { "--i": 2 },
                  attrs: { type: "custom" }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "password__badges-item-content typographies-paragraph-medium-regular"
                    },
                    [
                      _c("CompassIcon", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasNumber,
                            expression: "hasNumber"
                          }
                        ],
                        attrs: {
                          type: "primary-contrast",
                          size: "small",
                          icon: "check"
                        }
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              "inputs.PasswordWithBadgeInput.one_number"
                            )
                          ) +
                          "\n            "
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }